import { isPseudoLocale, toCortexLocale } from './pseudo_locale.helpers';
const isSupported = (siteLocales, locale) => !!locale && siteLocales.some((supported) => toCortexLocale(supported) === toCortexLocale(locale));
/**
 * Pure resolver for the study-scoped locale. A pseudo-locale is a browser-only testing override and
 * takes precedence. A valid STAT screenshot override is next. Otherwise the global shell/profile
 * locale is the default whenever the site supports it. When it is unavailable, a sole real site
 * locale is applied automatically. Sites with multiple real locales require an explicit picker
 * selection on every study entry because Axon does not distinguish its default locale from a
 * user-selected value.
 */
export const resolveStudyLocale = ({ siteLocales, pseudoLocale, statLocaleOverride, axonLocale, sessionLocale, rootLocale, }) => {
    if (pseudoLocale && isPseudoLocale(pseudoLocale)) {
        return { action: 'use', locale: pseudoLocale };
    }
    if (rootLocale && isPseudoLocale(rootLocale)) {
        return { action: 'use', locale: rootLocale };
    }
    if (statLocaleOverride && !isPseudoLocale(statLocaleOverride) && isSupported(siteLocales, statLocaleOverride)) {
        return { action: 'use', locale: statLocaleOverride };
    }
    if (isSupported(siteLocales, rootLocale)) {
        return { action: 'use', locale: rootLocale };
    }
    const realSiteLocales = siteLocales.filter((locale) => !isPseudoLocale(locale));
    if (realSiteLocales.length === 1) {
        return { action: 'use', locale: realSiteLocales[0] };
    }
    if (isSupported(siteLocales, sessionLocale)) {
        return { action: 'use', locale: sessionLocale };
    }
    const suggestedLocale = realSiteLocales.find((locale) => !!axonLocale && toCortexLocale(locale) === toCortexLocale(axonLocale)) ??
        realSiteLocales[0];
    return suggestedLocale ? { action: 'prompt', locale: suggestedLocale } : { action: 'prompt' };
};
